import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import React from 'react'

const PrivacyPolicy=()=> {
  return (
   <Grid>
    <Typography>sdfghjkl</Typography>
   </Grid>
  )
}

export default PrivacyPolicy